import { FC } from 'react';

import MastercardIcon from '@components/MasterCardIcon';
import VisaIcon from '@components/VisaIcon';
import AmericanExpressIcon from '@components/AmexIcon';

import { IconProps } from '@yaydoo/react-components/lib/icons/types';
export const Brands = {
  AmericanExpress: 'American Express',
  Mastercard: 'Mastercard',
  Visa: 'Visa',
};

export const getCardIcon = (brand: string): FC<IconProps> | null => {
  switch (brand) {
    case Brands.AmericanExpress:
      return AmericanExpressIcon;
    case Brands.Mastercard:
      return MastercardIcon;
    case Brands.Visa:
      return VisaIcon;
    default:
      return null;
  }
};

export const getCardType = (cc: string) => {
  const amex = new RegExp('^3[47][0-9]{13}$');
  const visa = new RegExp('^4[0-9]{12}(?:[0-9]{3})?$');
  const mastercard = new RegExp('^5[1-5][0-9]{14}$');
  const mastercard2 = new RegExp('^2[2-7][0-9]{14}$');

  if (visa.test(cc)) {
    return Brands.Visa;
  }
  if (amex.test(cc)) {
    return Brands.AmericanExpress;
  }
  if (mastercard.test(cc) || mastercard2.test(cc)) {
    return Brands.Mastercard;
  }

  return undefined;
};

export const redPayCardType = {
  [Brands.Visa]: '001',
  [Brands.AmericanExpress]: '002',
  [Brands.Mastercard]: '003',
};
